<template>
  <div class="scheduler__users__user__subpools__meta"
       :style="[
       {'left': itemBCR.right + 4 + 'px'},
       {'top': posTop + 'px'}
       ]">
    <table>
      <thead class="subPools__table__header">
      <tr>
        <th colspan="3">
          {{ $t('vue2.sub_scheduler_sub_pools.substitute_hours')}}
        </th>
      </tr>
      <tr>
        <th>{{ $t('vue2.sub_scheduler_sub_pools.difference')}}</th>
        <th>{{ $t('vue2.sub_scheduler_sub_pools.assigned')}}</th>
        <th>{{ $t('vue2.sub_scheduler_sub_pools.scheduled')}}</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>{{ itemSubPoolDiff }}</td>
        <td>{{itemSubPool}}</td>
        <td>{{ item.substituteHours }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    props: {
      item: {},
      itemBCR: {}
    },
    computed: {
      posTop () {
        return this.itemBCR.top - 15
      },
      itemSubPool () {
        return (this.item.current_user_year && this.item.current_user_year.substitute_pool_hours) || 0
      },
      itemSubPoolDiff () {
        return (this.itemSubPool - this.item.substituteHours).toFixed(1)
      }
    }
  }
</script>

<style scoped>
  .scheduler__users__user__subpools__meta {
    position: fixed;
    top: 0;
    left: 0;
    background-color: white;
    z-index: 1000;
    font-size: 10px;
    font-weight: bold;
    width: calc(60px * 3);
    text-align: center;
    box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -7px rgba(0, 0, 0, 0.2);
  }

  .scheduler__users__user__subpools__meta:after, .scheduler__users__user__subpools__meta:before {
    right: 100%;
    top: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  .scheduler__users__user__subpools__meta:before {
    border-color: rgba(194, 225, 245, 0);
    border-right-color: #ffffff;
    border-width: 10px;
    margin-top: 0px;
    top: 24px;
  }

  .scheduler__users__user__subpools__meta table {
    border-collapse: collapse;
  }

  .scheduler__users__user__subpools__meta table thead th {
    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
    text-align: center;
    padding: 0px 4px;
    width: 60px;
  }

  .scheduler__users__user__subpools__meta td {
    border: 1px solid rgba(217, 217, 217, .7);
  }

</style>



// WEBPACK FOOTER //
// SchedulerSubSubstituteHours.vue?987a3e06